import { createSlice } from "@reduxjs/toolkit";

export const clusterSlice = createSlice({
    name: 'cluster',
    initialState: {
        value: {},
        checked: false
    },
    reducers: {
        setCluster: (state, action) => {
            state.value = action.payload;
        },
        setClusterChecked: (state, action) => {
            state.checked = action.payload;
        }
    }
})

export const { setCluster, setClusterChecked } = clusterSlice.actions;

export const getCluster = (state) => state.cluster.value;
export const getClusterChecked = (state) => state.cluster.checked;

export default clusterSlice.reducer;